<template>
  <NewShopNoWebhookBot />
</template>
<script>
import NewShopNoWebhookBot from "@/components/NewShopNoWebhookBot";
export default {
  components: {
    NewShopNoWebhookBot
  }
}
</script>